import { AxiosInstance } from 'axios';

/**
 * Remove *.api.manheim.com domains from URLs, and returns relative paths with no domain
 */
export const stripManheimDomainsFromRequestUrl = (client: AxiosInstance) => {
  client.interceptors.request.use(config => {
    const url = config.url || '';
    const matches = /^.*?\/\/(.*?)\//.exec(url);
    const strippedUrl = matches && /api\.manheim\.com/.test(matches[0] || '') ? url.replace(/^.*?\/\/.*?\//, '/') : url;
    return {
      ...config,
      url: strippedUrl
    };
  });
};
